module.exports = __webpack_public_path__ + "img/RBSOVEN70LM2.1312d34f.png";